import React from 'react';
import * as Styles from './EmptyTableBody.styles';
import { useConsumeWeaveTheme, useWeaveContext, } from '../../hocs/ApplicationWrapper/theme/WeaveContext';
export default function EmptyTableBody(props) {
    const { resolvedRoles, isWeaveTheme } = useConsumeWeaveTheme();
    const { theme } = useWeaveContext();
    const color = React.useMemo(() => {
        if (!isWeaveTheme)
            return props.color;
        return resolvedRoles['colorScheme.text.default'];
    }, [theme, isWeaveTheme, resolvedRoles]);
    const iconColor = React.useMemo(() => {
        if (!isWeaveTheme)
            return props.iconColor;
        return resolvedRoles['colorScheme.icon.default'];
    }, [theme, isWeaveTheme, resolvedRoles]);
    const titleColor = React.useMemo(() => {
        if (!isWeaveTheme)
            return props.titleColor;
        return resolvedRoles['typography.h2.color'];
    }, [theme, isWeaveTheme, resolvedRoles]);
    return (React.createElement(Styles.Wrapper, { className: props.className, "data-cy": props.dataCy, color: color },
        React.createElement(Styles.Content, null,
            React.createElement(Styles.IconWrapper, { color: color, iconcolor: iconColor }, props.icon),
            React.createElement(Styles.Title, { color: color, titlecolor: titleColor, variant: "heading-medium-strong" }, props.title),
            React.createElement(Styles.Caption, { color: color, variant: "caption" }, props.subtitle),
            React.createElement(Styles.CTA, null, props.CTA))));
}
